var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1996 3.35952L13.1692 3.43052L10.2278 10.2567H7.33708C6.64736 10.2567 5.98808 10.3987 5.38965 10.6522L7.16465 6.41252L7.20522 6.31109L7.27622 6.14881C7.29651 6.08795 7.31679 6.02709 7.34722 5.97638C8.67593 2.90309 10.1771 2.20324 13.1996 3.35952Z",
    stroke: "#2678F2",
    strokeWidth: 1.30408,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6666 10.4594C18.2102 10.3174 17.7234 10.2565 17.2365 10.2565H10.2278L13.1692 3.43038L13.1996 3.35938C13.3518 3.41009 13.4938 3.48109 13.6459 3.54195L15.8875 4.48523C17.1351 5.00252 18.0074 5.54009 18.5348 6.18923C18.6362 6.31095 18.7174 6.42252 18.7884 6.55438C18.8796 6.69638 18.9506 6.83838 18.9912 6.99052C19.0318 7.0818 19.0622 7.17309 19.0825 7.25423C19.3564 8.10623 19.1941 9.15095 18.6666 10.4594Z",
    stroke: "#2678F2",
    strokeWidth: 1.30408,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1884 15.2056V17.1834C22.1884 17.3863 22.1782 17.5891 22.1681 17.792C21.9754 21.3319 19.9975 23.117 16.2447 23.117H8.33323C8.0898 23.117 7.84637 23.0967 7.61309 23.0663C4.38766 22.8533 2.66337 21.129 2.45037 17.9036C2.41994 17.6703 2.39966 17.4269 2.39966 17.1834V15.2056C2.39966 13.1669 3.63709 11.4121 5.40194 10.6514C6.01052 10.3979 6.65966 10.2559 7.34937 10.2559H17.2488C17.7458 10.2559 18.2327 10.3269 18.6789 10.4587C20.6974 11.0774 22.1884 12.964 22.1884 15.2056Z",
    stroke: "#2678F2",
    strokeWidth: 1.30408,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16474 6.41211L5.38974 10.6518C4.49931 11.0349 3.74051 11.6703 3.20699 12.4796C2.67347 13.2888 2.38857 14.2366 2.38745 15.206V12.2341C2.38745 9.35354 4.43631 6.94968 7.16474 6.41211ZM22.1853 12.2341V15.206C22.1853 12.9745 20.7044 11.0778 18.6759 10.4693C19.2033 9.15068 19.3554 8.11611 19.1019 7.25397C19.0816 7.16268 19.0512 7.0714 19.0106 6.99025C20.8972 7.96397 22.1853 9.96211 22.1853 12.2341Z",
    stroke: "#2678F2",
    strokeWidth: 1.30408,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/walletIcon.ed8fb018bed13e713c90cb3a9334e777.svg";
export { ForwardRef as ReactComponent };